import { Home, Shirt, Sparkles, ShoppingCart, Trees, Wrench, UtensilsCrossed, FileText, Package, Leaf } from 'lucide-react';

export const SERVICES = [
  {
    id: 'entretien-menager',
    title: 'Entretien ménager du domicile',
    shortDesc: 'Un chez-vous toujours propre et accueillant',
    icon: Home,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1585737757692-28c2c33e5d95?w=800&h=500&fit=crop',
    included: [
      'Dépoussiérage complet de toutes les surfaces',
      'Aspiration et lavage des sols',
      'Nettoyage de la cuisine (plans de travail, évier, électroménager)',
      'Nettoyage des sanitaires (salle de bain, WC)',
      'Rangement courant',
      'Changement des draps (sur demande)'
    ],
    benefits: [
      'Un intérieur sain et agréable au quotidien',
      'Du temps libre pour profiter de vos proches',
      'Un Easer dédié qui connaît vos habitudes',
      'Intervention régulière ou ponctuelle'
    ],
    description: "Notre service d'entretien ménager vous garantit un domicile impeccable. Votre Easer dédié prend en charge l'ensemble du ménage selon vos préférences et votre rythme. Profitez d'un intérieur toujours propre sans effort, pour moins de 15€/h après avance immédiate."
  },
  {
    id: 'entretien-linge',
    title: 'Entretien du linge / Repassage',
    shortDesc: 'Des vêtements toujours impeccables',
    icon: Shirt,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1489274495757-95c7c837b101?w=800&h=500&fit=crop',
    included: [
      'Tri et mise en machine du linge',
      'Repassage soigné de tous vos vêtements',
      'Pliage et rangement dans les armoires',
      'Traitement des taches courantes',
      'Entretien du linge délicat'
    ],
    benefits: [
      'Fini les piles de linge qui s\'accumulent',
      'Des vêtements toujours prêts à porter',
      'Un repassage professionnel et soigné',
      'Gain de temps considérable'
    ],
    description: "Ne perdez plus de temps avec le repassage et l'entretien du linge. Votre Easer s'occupe de tout : tri, lavage, repassage et rangement. Retrouvez des vêtements impeccables sans effort."
  },
  {
    id: 'nettoyage-vitres',
    title: 'Nettoyage des vitres',
    shortDesc: 'Des vitres étincelantes toute l\'année',
    icon: Sparkles,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1651481127251-60027d79519f?w=800&h=500&fit=crop',
    included: [
      'Nettoyage intérieur et extérieur des vitres',
      'Nettoyage des encadrements et rebords',
      'Nettoyage des volets (accessible)',
      'Nettoyage des baies vitrées',
      'Nettoyage des miroirs'
    ],
    benefits: [
      'Une luminosité optimale dans votre intérieur',
      'Des vitres sans traces',
      'Un nettoyage professionnel en toute sécurité',
      'Intervention ponctuelle ou saisonnière'
    ],
    description: "Profitez de vitres parfaitement propres et d'une luminosité maximale dans votre intérieur. Nos Easers utilisent des techniques professionnelles pour un résultat sans traces."
  },
  {
    id: 'courses-sorties',
    title: 'Aide aux courses et sorties / Drives',
    shortDesc: 'Vos courses sans contrainte',
    icon: ShoppingCart,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1588964895597-cfccd6e2dbf9?w=800&h=500&fit=crop',
    included: [
      'Accompagnement aux courses en magasin',
      'Récupération des commandes Drive',
      'Aide au rangement des courses',
      'Accompagnement pour sorties diverses',
      'Aide à la préparation de liste de courses'
    ],
    benefits: [
      'Plus besoin de porter de charges lourdes',
      'Accompagnement bienveillant et convivial',
      'Flexibilité sur les jours et horaires',
      'Maintien du lien social'
    ],
    description: "Nous vous accompagnons pour vos courses et sorties, ou récupérons vos commandes Drive. Un service pratique et convivial pour vous faciliter le quotidien."
  },
  {
    id: 'espaces-verts',
    title: 'Entretien des espaces verts / Jardinage',
    shortDesc: 'Un jardin toujours soigné',
    icon: Trees,
    priceBefore: 49.90,
    priceAfter: 24.95,
    unit: 'h',
    category: 'jardin',
    image: 'https://images.unsplash.com/photo-1734303023491-db8037a21f09?w=800&h=500&fit=crop',
    included: [
      'Tonte de la pelouse',
      'Taille des haies et arbustes',
      'Désherbage des massifs et allées',
      'Ramassage des feuilles',
      'Entretien courant des espaces verts',
      'Petit élagage'
    ],
    benefits: [
      'Un jardin agréable en toute saison',
      'Un professionnel équipé et expérimenté',
      'Moins de 25€/h après avance immédiate',
      'Intervention adaptée à la saison'
    ],
    description: "Confiez l'entretien de votre jardin à nos Easers qualifiés. De la tonte à la taille des haies, nous prenons soin de vos espaces verts toute l'année, pour moins de 25€/h après avance immédiate."
  },
  {
    id: 'petit-bricolage',
    title: 'Petit bricolage / Homme toutes mains',
    shortDesc: 'Les petits travaux en toute simplicité',
    icon: Wrench,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1581783898377-1c85bf937427?w=800&h=500&fit=crop',
    included: [
      'Montage de meubles en kit',
      'Fixation d\'étagères et cadres',
      'Petites réparations courantes',
      'Changement d\'ampoules, joints, etc.',
      'Installation de petit équipement'
    ],
    benefits: [
      'Plus besoin d\'attendre pour les petits travaux',
      'Un professionnel expérimenté et équipé',
      'Intervention rapide et soignée',
      'Tarif transparent, pas de surprise'
    ],
    description: "Pour tous vos petits travaux du quotidien, faites appel à nos hommes toutes mains. Montage, fixation, réparation : nous intervenons rapidement et efficacement."
  },
  {
    id: 'aide-repas',
    title: 'Aide aux repas',
    shortDesc: 'Des repas équilibrés sans effort',
    icon: UtensilsCrossed,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1591189863430-ab87e120f312?w=800&h=500&fit=crop',
    included: [
      'Préparation de repas équilibrés',
      'Aide à la prise des repas si besoin',
      'Vaisselle et rangement de la cuisine',
      'Adaptation aux régimes alimentaires',
      'Préparation de repas en avance'
    ],
    benefits: [
      'Une alimentation saine et variée',
      'Respect de vos goûts et habitudes',
      'Un moment convivial et chaleureux',
      'Accompagnement bienveillant'
    ],
    description: "Notre service d'aide aux repas vous permet de profiter de repas équilibrés et savoureux, préparés avec soin par votre Easer, dans le respect de vos goûts et besoins."
  },
  {
    id: 'assistance-administrative',
    title: 'Assistance administrative',
    shortDesc: 'Vos démarches simplifiées',
    icon: FileText,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'domicile',
    image: 'https://images.unsplash.com/photo-1632152133952-98b268dc4b86?w=800&h=500&fit=crop',
    included: [
      'Aide au classement et tri du courrier',
      'Aide aux démarches administratives simples',
      'Aide à la rédaction de courriers',
      'Accompagnement pour les démarches en ligne',
      'Organisation des documents'
    ],
    benefits: [
      'Fini le stress des papiers en retard',
      'Un accompagnement patient et bienveillant',
      'Confidentialité garantie',
      'Aide adaptée à votre rythme'
    ],
    description: "Ne vous laissez plus submerger par les démarches administratives. Votre Easer vous aide à organiser, classer et traiter vos documents en toute confidentialité."
  },
  {
    id: 'global-service-domicile',
    title: 'Global Service Entretien du Domicile',
    shortDesc: 'Tout est inclus, un seul interlocuteur',
    icon: Package,
    priceBefore: 29.99,
    priceAfter: 14.99,
    unit: 'h',
    category: 'global',
    image: 'https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?w=800&h=500&fit=crop',
    isGlobal: true,
    included: [
      'Entretien ménager complet du domicile',
      'Nettoyage des vitres',
      'Repassage et entretien du linge',
      'Accompagnement aux courses et sorties',
      'Récupération des Drives',
      'Accompagnement personnalisé au quotidien',
      'Un Easer attitré qui connaît votre domicile',
      'Planification prioritaire',
      'Suivi qualité régulier'
    ],
    benefits: [
      'Un seul prestataire pour TOUS vos besoins du domicile',
      'Un Easer dédié à votre disposition pour le temps que vous choisissez',
      'Tout est inclus, c\'est à la demande : vous décidez des priorités',
      'Simplicité : un seul contrat, une seule facture',
      'Tarifs transparents : tout est clair, pas de surprise',
      'Moins de 15€/h après avance immédiate'
    ],
    description: "L'offre Global Service Entretien du Domicile, c'est la tranquillité totale. Nous mettons notre personnel à votre disposition pour la durée que vous choisissez. Tout est inclus et c'est à la demande : ménage, vitres, repassage, courses, drives, accompagnement personnalisé... Votre Easer attitré s'adapte à vos priorités du jour. Un seul interlocuteur, un seul contrat, des tarifs transparents. NB : la charge de travail réalisable est en fonction de la durée de prestation choisie."
  },
  {
    id: 'global-service-jardin',
    title: 'Global Service Entretien du Jardin',
    shortDesc: 'Votre jardin entre de bonnes mains',
    icon: Leaf,
    priceBefore: 49.90,
    priceAfter: 24.95,
    unit: 'h',
    category: 'global',
    image: 'https://images.unsplash.com/photo-1776211849372-d5b269c9d01c?w=800&h=500&fit=crop',
    isGlobal: true,
    included: [
      'Tonte et entretien de la pelouse',
      'Taille des haies, arbustes et rosiers',
      'Désherbage et entretien des massifs',
      'Ramassage des feuilles et déchets verts',
      'Petit élagage et entretien saisonnier',
      'Un Easer jardinier attitré',
      'Planification saisonnière adaptée',
      'Suivi qualité régulier'
    ],
    benefits: [
      'Votre jardinier à disposition pour le temps que vous choisissez',
      'Tout est inclus, à la demande : vous définissez les priorités',
      'Un jardinier dédié qui connaît votre jardin',
      'Entretien adapté à chaque saison',
      'Tarifs transparents : tout est clair, pas de surprise',
      'Moins de 25€/h après avance immédiate'
    ],
    description: "L'offre Global Service Entretien du Jardin : nous mettons notre jardinier à votre disposition pour la durée que vous choisissez. Tout est inclus et c'est à la demande. Tonte, taille, désherbage, ramassage : votre Easer jardinier attitré s'adapte à vos priorités et aux saisons. Tarifs transparents, pas de surprise. NB : la charge de travail réalisable est en fonction de la durée de prestation choisie."
  }
];

export const getServiceById = (id) => SERVICES.find(s => s.id === id);

export const getServicesByCategory = (category) => SERVICES.filter(s => s.category === category);

export const getGlobalServices = () => SERVICES.filter(s => s.isGlobal);
